export default {
  title:       'Gestão dos meus dados',
  description: 'Confirmação da existência de tratamento',
};
